export const BUILD_VERSION = '1792036613';
